document.addEventListener("alpine:init", () => {
    Alpine.data("navigation", () => {
        return {
            active: false,
            activeMobile: false,
            activeMenuSegment: "",
            activeMenuGroup: 0,
            mobileState: 0,
            login: false,

            setActiveMenuSegment(e) {
                this.activeMenuSegment = e.currentTarget.dataset.id;
                let segmentElement = this.$refs[this.activeMenuSegment];
                let segmentFirstGroup = segmentElement.querySelector(".nav-menu-segment__sidebar__link");
                let segmentHighlight = segmentElement.querySelector(".nav-menu-segment__sidebar__bg");

                if (segmentFirstGroup && segmentHighlight) {
                    segmentElement.classList.add("hoverLink");
                    setTimeout(() => {
                        segmentHighlight.classList.add("transition-none");
                        segmentHighlight.style.height = segmentFirstGroup.offsetHeight + "px";
                        segmentHighlight.style.transform = "translateY(" + segmentFirstGroup.offsetTop + "px)";
                        segmentHighlight.classList.remove("transition-none");
                    }, 20);
                }

                if (segmentElement.children[1].children[1].dataset.type === "group" || window.screen.width < 1025)
                    segmentElement.classList.remove("hoverLink");

                this.activeMenuGroup = 0;
                this.setActiveSidebarLinks();
            },
            setActiveMenuSegmentMobile(e) {
                this.setActiveMenuSegment(e);
                this.mobileState = 1;
            },
            setActiveSidebarLinks() {
                let activeGroupLinks = this.$refs["pages-" + this.activeMenuSegment];
                if (activeGroupLinks) {
                    for (const [i, group] of activeGroupLinks.childNodes.entries()) {
                        if (i < this.activeMenuGroup) {
                            group.classList.remove("active", "below");
                            group.classList.add("above");
                        } else if (i == this.activeMenuGroup) {
                            group.classList.remove("above", "below");
                            group.classList.add("active");
                        } else {
                            group.classList.remove("above", "active");
                            group.classList.add("below");
                        }
                    }
                }
            },
            setHover(e) {
                let hoverHighlight = e.currentTarget.parentNode.querySelector(".nav-menu-segment__sidebar__bg");
                hoverHighlight.style.height = e.currentTarget.offsetHeight + "px";
                hoverHighlight.style.transform = "translateY(" + e.currentTarget.offsetTop + "px)";
            },
            setActiveMenuGroup(e) {
                e.currentTarget.parentNode.parentNode.classList.remove("hoverLink");
                this.activeMenuGroup = [...e.currentTarget.parentNode.childNodes].indexOf(e.currentTarget) - 1;
                this.setHover(e);
            },
            setActiveMenuGroupMobile(e) {
                this.activeMenuGroup = [...e.currentTarget.parentNode.childNodes].indexOf(e.currentTarget) - 1;
                if (this.mobileState > 0) {
                    this.mobileState = 2;
                    e.preventDefault();
                }
            },
            setActiveMenuLink(e) {
                e.currentTarget.parentNode.parentNode.classList.add("hoverLink");
                this.setHover(e);
            },
            openNav(e) {
                if (!e.currentTarget.dataset.id) {
                    this.active = false;
                    this.hideNav();
                    this.activeMenuSegment = "";
                    this.activeMenuGroup = 0;
                    return;
                }
                this.setActiveMenuSegment(e);
                this.active = true;
                this.$refs.arrowMain.style.transform =
                    "translateX(" +
                    (e.currentTarget.offsetLeft * 0.25 + e.currentTarget.offsetWidth / 2 - 20) +
                    "px) rotate(45deg)";
                this.$refs.menu.style.transform = "translateX(" + e.currentTarget.offsetLeft * 0.75 + "px)";
            },
            hideNav() {
                this.active = false;
                this.activeMenuSegment = "";
                this.activeMenuGroup = 0;
            },
            openLogin($e) {
                if (document.querySelector("body.neos-backend")) {
                    let target = false;

                    do {
                        target = target ? target.parentNode : $e.target;
                        if (target.contentEditable === "true") {
                            return;
                        }
                    } while (!target.classList.contains("c-button"));
                }
                this.login = true;
                document.body.classList.add("modalOpen");
            },
            hideLogin($e) {
                if (document.querySelector("body.neos-backend")) {
                    let target = false;

                    do {
                        target = target ? target.parentNode : $e.target;
                        if (target.contentEditable === "true") {
                            return;
                        }
                    } while (target !== document);
                }
                this.login = false;
                this.active = false;
                this.mobileState = 0;
                this.activeMenuSegment = "";
                this.$refs.navigation.classList.remove("activeMobile");
                document.body.classList.remove("modalOpen");
            },
            toggleNavMobile() {
                this.activeMobile = !this.activeMobile;
                this.active = this.activeMobile;
                this.mobileState = 0;
                this.activeMenuSegment = "";
                this.activeMenuGroup = "";

                if (this.activeMobile) {
                    this.$refs.navigation.classList.add("activeMobile");
                    document.body.classList.add("modalOpen");
                } else {
                    this.$refs.navigation.classList.remove("activeMobile");
                    document.body.classList.remove("modalOpen");
                }
            },
            backState() {
                this.mobileState = this.mobileState - 1;
            },
            init() {
                this.$watch("activeMenuGroup", (value) => this.setActiveSidebarLinks(value));
            },
        };
    });
});

document.addEventListener("scroll", () => {
    if (window.scrollY > 0) {
        document.body.classList.add("scrolled");
    } else {
        document.body.classList.remove("scrolled");
    }
});
